import AdditionalSteps from '../http/additionalSteps'
import Jwt from './jwt'

export default class AdditionalStepsService {
  static async getWotcWithToken (postingId, token) {
    const response = await AdditionalSteps.getWotcWithToken(postingId, token, Jwt.getIdToken())
    return response.data
  }
}
